import { render } from "./InvitationImageComponent.vue?vue&type=template&id=7c2f8374&scoped=true"
import script from "./InvitationImageComponent.vue?vue&type=script&lang=js"
export * from "./InvitationImageComponent.vue?vue&type=script&lang=js"

import "./InvitationImageComponent.vue?vue&type=style&index=0&id=7c2f8374&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7c2f8374"]])

export default __exports__